import { Injectable } from '@angular/core';
import { Store } from '../store';

@Injectable({
    providedIn: 'root'
})
export class StorageService {

    constructor(
        private store: Store,
    ) {
    }

    setLoggedIn(status = true) {
        localStorage.setItem('yssAdminLoggedIn', JSON.stringify(status));
    }

    setUser(data) {
        let decodedCookie = {
            token: '',
            user: undefined,
        };
        const cookieData = localStorage.getItem('yssAdminUser');
        if (cookieData) {
            decodedCookie = JSON.parse(cookieData);
        }
        decodedCookie.user = data;
        localStorage.setItem('yssAdminUser', JSON.stringify(decodedCookie));
    }

    remove() {
        localStorage.removeItem('yssAdminLoggedIn');
        localStorage.removeItem('yssAdminUser');
        this.store.set('user', undefined);
        this.store.set('token', '');
    }


    check() {
        let data;
        try {
            data = JSON.parse(localStorage.getItem('yssAdminLoggedIn'));
        } catch {
            data = undefined;
        }
        if (data) {
            this.store.set('loggedIn', true);
            return true;
        }

        this.store.set('user', undefined);
        this.store.set('token', '');
        this.store.set('loggedIn', false);
        return false;
    }

    checkUser() {
        if (localStorage.getItem('yssAdminUser')) {
            const localStoredData = JSON.parse(localStorage.getItem('yssAdminUser'));
            if (!localStoredData.user) {
                this.handleNoUser();
                return false;
            }
            this.store.set('user', localStoredData.user);
            this.store.set('accountType', localStoredData.user.accountType);
            return true;
        } else {
            this.handleNoUser();
            return false;
        }
    }

    handleNoUser() {
        this.store.set('user', undefined);
        this.store.set('loggedIn', false);
        this.store.set('accountType', '');
    }

    async isAuthenticated() {
        const promise = new Promise(
            (resolve, reject) => {
                resolve(this.check());
            }
        );
        return promise;
    }

    hasUserData() {
        const promise = new Promise(
            (resolve, reject) => {
                resolve(this.store.selectForLocal('user'));
            }
        );
        return promise;
    }


}
